import React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

function FullscreenIcon(props: SvgIconProps) {
  return (
    <SvgIcon width={24} height={24} viewBox="0 0 24 24" {...props}>
      <path d="M19 3h-5v2h3.59l-4.66 4.66 1.41 1.41L19 6.41V10h2V3h-2zM4.93 21H10v-2H6.34L11 14.38l-1.38-1.4L5 17.66V14H3v7h1.93z" />
    </SvgIcon>
  );
}

export default FullscreenIcon;
